<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <!-- <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>User Permission Set</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                </div>
            </div> -->
            <div class="card p-mt-4">
                <DataTable :value="userRoles" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Permission Sets</h5>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Role Permission" icon="pi pi-plus" @click="toAddRoles" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Role Name" field="mbz2" class="p-text-capitalize" headerStyle="width: 35%">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data: { mbz4 } }">
                            <span v-if="mbz4 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="mbz4 == 2" :class="'user-badge status-temp-suspend'">Temporarily
                                Suspended</span>
                            <span v-if="mbz4 == 3" :class="'user-badge status-per-suspend'">Permanently
                                Suspended</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editUserRoleModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddRole" :style="{ width: '800px' }" :modal="true" class="p-fluid" header="Add New Role">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="roleName">
                            Role Name
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="roleName" v-model.trim="roleName" required="true" maxlength="30" autofocus
                            :class="{ 'p-invalid': isSubmitted && !roleName }" />
                        <small class="p-invalid p-error" v-if="v$.roleName.$error">{{
                            v$.roleName.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label style="margin-bottom: 2%;"> Select Menu <span class="p-invalid p-error"> *
                            </span></label>
                            <div class="p-grid" style="margin-bottom: 1%;">
                                <div v-if="!isExpanded" class="p-col-3 p-md-3">
                                <Button  label="Expand All" @click="toggleExpand" icon="pi pi-plus" />
                            </div>
                            <div v-if="isExpanded" class="p-col-3 p-md-3">
                                <Button  label="Collapse All" @click="toggleExpand" icon="pi pi-minus" />
                            </div>
                            <div class="p-col-3 p-md-3">
                                <Button 
                                    :label="isAllSelected ? 'Unselect All' : 'Select All'" 
                                    @click="toggleSelectAll" 
                                    :icon="isAllSelected ? 'pi pi-times' : 'pi pi-check'" 
                                />
                            </div>
                        </div>
                        <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                            :expandedKeys="expandedKeys" class="custom-users-role">
                        </Tree>
                        <small class="p-invalid p-error" v-if="v$.selectedTreeValue.$error">
                            {{ v$.selectedTreeValue.$errors[0].$message }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addUserPermissionSet" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button> -->
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit User Role" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="roleName">
                            Role Name
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="roleName" v-model.trim="roleName" required="true" maxlength="30" autofocus
                            :class="{ 'p-invalid': isSubmitted && !roleName }" />
                        <small class="p-invalid p-error" v-if="v$.roleName.$error">{{
                            v$.roleName.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status <span class="p-invalid p-error"> *</span></label>
                        <div class="p-field-radiobutton">
                            <RadioButton id="active_type" name="option" v-bind:value="1" v-model="status"
                                :checked="status == 1" />
                            <label for="active_type" class="p-mr-2">Active</label>
                            <RadioButton id="Inactive_type" name="option" v-bind:value="2" v-model="status"
                                :checked="status == 2" />
                            <label for="Inactive_type" class="p-mr-2">Inactive</label>
                        </div>
                        <small class="p-invalid p-error" v-if="v$.status.$error">{{
                            v$.status.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label style="margin-bottom: 2%;"> Select Menu <span class="p-invalid p-error"> *
                            </span></label>
                        <div class="p-grid" style="margin-bottom: 1%;">
                            <div v-if="!isExpanded" class="p-col-3 p-md-3">
                                <Button label="Expand All" @click="toggleExpand" icon="pi pi-plus" />
                            </div>
                            <div v-if="isExpanded" class="p-col-3 p-md-3">
                                <Button label="Collapse All" @click="toggleExpand" icon="pi pi-minus" />
                            </div>
                            <div class="p-col-3 p-md-3">
                                <Button 
                                    :label="isAllSelected ? 'Unselect All' : 'Select All'" 
                                    @click="toggleSelectAll" 
                                    :icon="isAllSelected ? 'pi pi-times' : 'pi pi-check'" 
                                />
                            </div>
                        </div>
                        <Tree :value="nodes" selectionMode="checkbox" v-model:selectionKeys="selectedTreeValue"
                            :expandedKeys="expandedKeys" class="custom-users-role">
                        </Tree>
                        <small class="p-invalid p-error" v-if="v$.selectedTreeValue.$error">
                            {{ v$.selectedTreeValue.$errors[0].$message }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editUserRole" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px" appendTo="body"></Button> -->
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import router from '@/router';
import { required, helpers, requiredIf } from '@vuelidate/validators';

export default {
    data() {
        return {
            userRoles: [],
            v$: useValidate(),
            isAddRole: false,
            isSubmitted: false,
            roleName: "",
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            roles: [],
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            UserIdList: [],
            localAdminName: '',
            status: 1,
            isExpanded: false,

            userrole: '',
            expandedKeys: [],
            userrole_list: [],
            nodes: [],
            expandedRows: [],
            selectedTreeValue: [],
        };
    },
    validations() {
        return {
            roleName: { required: helpers.withMessage('Please enter role name', required) },
            status: { required: helpers.withMessage('Please select status', required) },
            selectedTreeValue: {
                requiredIf: helpers.withMessage(
                    "Please select module",
                    requiredIf(
                        this.roletype == 2
                    )
                ),
            },
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getSuperAdminUserRolesListing();
        this.getMenus();
    },
    computed: {
        isAllSelected() {
            if (!this.nodes || this.nodes.length === 0) return false;
            let allKeys = [];
            const collectKeys = (nodes) => {
                if (!nodes) return;
                nodes.forEach(node => {
                    allKeys.push(node.key);
                    if (node.children) {
                        collectKeys(node.children);
                    }
                });
            };
            collectKeys(this.nodes);
            return allKeys.every(key => this.selectedTreeValue[key] && this.selectedTreeValue[key].checked);
        }
    },
    methods: {
        getMenus() {
            this.loading = true;
            this.ApiService.getMenus().then((data) => {
                if (data.status == 200) {
                    this.nodes = data.data;
                } else {
                    this.nodes = '';
                }
                this.loading = false;
            });
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.unselectAll();
            } else {
                this.selectAll();
            }
        },
        selectAll() {
            let selectedKeys = {};
            const setSelected = (nodes) => {
                if (!nodes) return;
                nodes.forEach(node => {
                    selectedKeys[node.key] = { checked: true }; // Select node
                    if (node.children) {
                        setSelected(node.children);
                    }
                });
            };
            setSelected(this.nodes);
            this.selectedTreeValue = selectedKeys;
        },
        unselectAll() {
            this.selectedTreeValue = {}; // Clears all selections
        },
        toggleExpand() {
            if (this.isExpanded) {
                this.collapseAll();
            } else {
                this.expandAll();
            }
            this.isExpanded = !this.isExpanded; // Toggle the state
        },
        expandAll() {
            for (let node in this.nodes) {
                this.expandNode(this.nodes[node]);
            }
            this.expandedKeys = { ...this.expandedKeys };
        },

        collapseAll() {
            this.expandedKeys = {};
        },

        expandNode(node) {
            if (node.children && node.children.length) {
                this.expandedKeys[node.key] = true;
                for (let child of node.children) {
                    this.expandNode(child);
                }
            }
        },
        getAssignedRoles(val) {
            var res1 = val.split(',').map(Number);
            var res = Array.from(res1);
            let array = [];
            for (let i = 0; i < res.length; i++) {
                for (let j = 0; j < this.roles.length; j++) {
                    if (this.roles[j].value == res[i]) {
                        array.push(this.roles[j].label);
                    }
                }
            }
            return array.join(",");
        },
        getSuperAdminUserRolesListing() {
            this.ApiService.getSuperAdminUserRolesListing().then((items) => {
                if (items.status === 200) {
                    this.userRoles = items.data;
                    this.totalRecords = items.count;
                } else {
                    this.userRoles = [];
                }
            });
        },
        async toAddRoles() {
            this.isAddRole = true;
            this.isSubmitted = false;
            this.roleName = '';
            this.selectedTreeValue = [];
            this.v$.$reset();
        },
        addUserPermissionSet() {
            this.submitted = true;
            this.errormsg = '';

            this.v$.$validate();
            let formData = new FormData();
            formData.append('roleName', this.roleName);
            formData.append('modules', JSON.stringify(this.selectedTreeValue));
            formData.append('status', 1);
            formData.append('mbz1', 0);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.createUpdateUserPermissionSet(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getSuperAdminUserRolesListing();
                        this.isAddRole = false;
                        this.roleName = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editUserRoleModalOpen(data) {
            this.expandedKeys = {};
            this.isEditUserRole = true;
            this.roleName = '';

            this.status = data.mbz4;
            this.rowId = data.mbz1;
            this.roleName = data.mbz2;
            this.selectedTreeValue = [];
            if (data.mbz3 != null) {
                let arrConverted = data.mbz3.split(",");
                this.selectedTreeValue = {};
                for (let index = 0; index < arrConverted.length; index++) {
                    let idxx = parseInt(arrConverted[index]); // Ensure the key is treated as an integer
                    this.selectedTreeValue[idxx] = { checked: true, partialChecked: false };
                }
            }
        },
        editUserRole() {
            this.submitted = true;
            this.errormsg = '';

            this.v$.$validate();
            let formData = new FormData();
            formData.append('roleName', this.roleName);
            formData.append('modules', JSON.stringify(this.selectedTreeValue));
            formData.append('status', this.status);
            formData.append('mbz1', this.rowId);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.createUpdateUserPermissionSet(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getSuperAdminUserRolesListing();
                        this.isEditUserRole = false;
                        this.roleName = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getSuperAdminUserRolesListing({ page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
    }

};
</script>

<style scoped></style>
